import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FileRulesType } from '@astronautsid/wpe-utils'

import {
  type VendorDetailsInterface,
  type VendorDetailRequestInterface,
} from 'features/Enterprise/Vendor/types/VendorManagement'

export const SLICE_NAME = 'principalUpsert'

interface PrincipalUpsertStateInterface {
  isLoading: boolean
  fileRules: FileRulesType
  principalDetails: VendorDetailsInterface
  draftDetails: Omit<VendorDetailRequestInterface, 'request_data'>
  brandList: { id: number; name: string }[]
}

const initialState: PrincipalUpsertStateInterface = {
  isLoading: false,
  fileRules: {
    extensions: ['.pdf', '.jpg', '.jpeg', '.png'],
    maxFileSize: 10000000,
    typeId: 'commercial-vendors-invoices',
  },
  principalDetails: {} as VendorDetailsInterface,
  draftDetails: {} as VendorDetailRequestInterface,
  brandList: [],
}

const principalUpsert = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setFileRules: (state, action: PayloadAction<FileRulesType>) => {
      state.fileRules = action.payload
    },
    setPrincipalDetails: (state, action: PayloadAction<VendorDetailsInterface>) => {
      state.principalDetails = action.payload
    },
    setDraftDetails: (
      state,
      action: PayloadAction<Omit<VendorDetailRequestInterface, 'request_data'>>,
    ) => {
      state.draftDetails = action.payload
    },
    setBrandList: (state, action: PayloadAction<{ id: number; name: string }[]>) => {
      state.brandList = action.payload
    },
  },
})

export const { setLoading, setFileRules, setPrincipalDetails, setDraftDetails, setBrandList } =
  principalUpsert.actions
export default principalUpsert.reducer
